/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityRef
 */
export interface FacilityRef {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the FacilityRef interface.
 */
export function instanceOfFacilityRef(value: object): value is FacilityRef {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FacilityRefFromJSON(json: any): FacilityRef {
    return FacilityRefFromJSONTyped(json, false);
}

export function FacilityRefFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityRef {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FacilityRefToJSON(json: any): FacilityRef {
    return FacilityRefToJSONTyped(json, false);
}

export function FacilityRefToJSONTyped(value?: FacilityRef | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

